import * as React from 'react'

import { NextPage } from '@grandvisionhq/next'
import {
  ErrorCase,
  InitialProps,
  Page,
  Props,
} from '@grandvisionhq/www-next/pages/product-detail/solutions'
import { FullDateDeliveryIndicatorContainer } from '@grandvisionhq/www-next/slot-components/FullDateDeliveryIndicatorContainer'
import { PromoteInstallmentsGraphContainer } from '@grandvisionhq/www-next/slot-components/PromoteInstallmentsGraphContainer'

import { composePDP } from '../../../components/hocs/compose-pdp'
import { settings as cartSettings } from '../../../components/hocs/with-cart'
import { graphPromoteInstallmentsConfiguration } from '../../../configuration'

const slots: Props['slots'] = {
  AfterPrice: () => (
    <PromoteInstallmentsGraphContainer opcoConfiguration={graphPromoteInstallmentsConfiguration} />
  ),
  DynamicDeliveryIndicator: FullDateDeliveryIndicatorContainer,
}

const ProductDetailPage: NextPage<Props, InitialProps | ErrorCase> = (props) => {
  return (
    <Page
      {...props}
      slots={slots}
      bookAppointmentRouteConfig={{ route: 'stores.overview' }}
      maxOrderableQuantity={cartSettings.maximumQuantity}
    />
  )
}

ProductDetailPage.getInitialProps = Page.getInitialProps

export default composePDP<Props>(ProductDetailPage)
